import { render, staticRenderFns } from "./UsersDepartmentDataTable.vue?vue&type=template&id=dfe71340&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./UsersDepartmentDataTable.vue?vue&type=script&lang=js&"
export * from "./UsersDepartmentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersDepartmentDataTable.vue?vue&type=style&index=0&id=dfe71340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe71340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDataTable,VFlex,VIcon,VLayout,VTextField,VTooltip})
